import DiscussionList from 'flarum/components/DiscussionList';

export default class PrivateDiscussionList extends DiscussionList
{
}
